import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import * as _ from "lodash";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";

export class subTasksTemplatesTableRowCtrl implements IController {

  template: any;
  canEdit: boolean;
  canEditSequenceIndex: boolean;
  canDelete: boolean;
  settingsValue: any;
  usedSequenceIndexList: number[];
  form: any;
  isShowEnabledPurpose: boolean;
  onEdit: Function;
  onEditSequenceIndex: Function;
  onDelete: Function;
  onSettingsValueChange: Function;
  onChangeEnabledPurposes: Function;


  public sequenceIndex?: number;
  public enabledPurposesMap = {};
  public taskPurposeTypes: typeof TaskPurposeType = TaskPurposeType;

  $onChanges(changes: IOnChangesObject) {
    if (changes.template || changes.settingsValue || changes.usedSequenceIndexList) {
      if (this.template && !!this.form && this.form[this.template.templateId + 'sequenceIndex']) {
        const sequence = this.settingsValue?.value?.sequenceIndex;
        let list = angular.copy(this.usedSequenceIndexList) || [];

        if (!_.isUndefined(sequence)) {
          const firstIndex = _.findIndex(list, (s) => {
            return s === sequence;
          })

          if (firstIndex > -1) {
            list.splice(firstIndex, 1);
          }

          const isExists = _.find(list, (s) => {
            return s === sequence;
          })
          this.form[this.template.templateId + 'sequenceIndex'].$setValidity('exists', !isExists);
        } else {
          this.form[this.template.templateId + 'sequenceIndex'].$setValidity('exists', true);
        }
      }

      if (this.isShowEnabledPurpose) {
        this.enabledPurposesMap = {};
        if (this.settingsValue?.value?.enabledPurpose) {
          this.settingsValue?.value?.enabledPurpose?.forEach((ep) => {
            this.enabledPurposesMap[ep] = true;
          })
        } else if (this.settingsValue?.parentValue?.enabledPurpose) {
          this.settingsValue?.parentValue?.enabledPurpose?.forEach((ep) => {
            this.enabledPurposesMap[ep] = true;
          })
        }
      }

      if (!!this.settingsValue?.value?.sequenceIndex) {
        this.sequenceIndex = this.settingsValue.value.sequenceIndex;
      }

    }
  };

  onSequenceChange(sequenceIndex) {
    this.onEditSequenceIndex({sequenceIndex: sequenceIndex, templateId: this.template.templateId});
  }

  toggleEnabledPurpose(purpose: TaskPurposeType) {
    if (!this.settingsValue.value) {
      this.settingsValue.value = {};
    }
    if (!this.settingsValue.value?.enabledPurpose) {
      this.settingsValue.value.enabledPurpose = this.settingsValue.parentValue?.enabledPurpose || [];
    }

    if (!this.enabledPurposesMap[purpose]) {
      const purposeIndex = this.settingsValue.value.enabledPurpose.findIndex(p => p === purpose);
      this.settingsValue.value.enabledPurpose.splice(purposeIndex, 1);
    } else {
      this.settingsValue.value.enabledPurpose.push(purpose);
    }

    this.onChangeEnabledPurposes({enabledPurpose: this.settingsValue.value.enabledPurpose});
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTasksTemplatesTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      template: '<',
      canEdit: '<?',
      canEditSequenceIndex: '<?',
      canDelete: '<?',
      usedSequenceIndexList: '<?',
      settingsValue: '<?',
      isShowEnabledPurpose: '<?',
      onEdit: '&',
      onEditSequenceIndex: '&',
      onDelete: '&',
      onSettingsValueChange: '&',
      onChangeEnabledPurposes: '&'
    },
    template: require('./sub-tasks-templates-table-row.html').default,
    controller: subTasksTemplatesTableRowCtrl
  });
